var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('banners-form',{attrs:{"form":_vm.form,"tabs":_vm.tabs},on:{"change":_vm.handleImage,"submit":_vm.submitForm}})}
var staticRenderFns = []

export { render, staticRenderFns }